import { Dialog, Grid, IconButton } from '@mui/material';
import Images from '../../../Utils/images';
import CustomButton from '../../../Components/CustomButton';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { updateCabService } from '../../../redux/riskCenterSlice';
import { RootState, useAppSelector } from '../../../redux/store';
import { useLocation, useNavigate } from 'react-router-dom';
import AutoCompleteLocation from '../../../Components/AutoCompleteLocation';
import { useForm } from 'react-hook-form';
import { getAddress, getCurrentLocation } from '../../../Utils/helperFns';
import { notify } from '../../../Utils/toastify';
import NoData from '../../../Components/Nodata';
import Loading from '../../../Components/Loading';
import SearchInput from '../../../Components/SearchComponent';
import ToolTipComponent from '../../../Components/ToolTipComponent';

interface Props {
  open: boolean;
  handleClose?: any;
  type?: string;
  pickupType?: string;
  handleLocation: (data: any) => void;
  getValues: any;
  index?: number;
}
// Utility function to Title Case each word

export default function SelectAddressDialog(props: Props) {
  const {
    open,
    handleClose,
    type,
    pickupType,
    getValues: getValuesFromParent,
    index,
  } = props;
  const navigate = useNavigate();

  const { loader } = useAppSelector((state: RootState) => state.order);
  const { businessAddress } = useAppSelector(
    (state: RootState) => state.riskCenter,
  );
  const [addressType, setAddressType] = useState('BUSINESS');
  const { t: tC } = useTranslation('translation', {
    keyPrefix: 'Common',
  });
  const { state } = useLocation();
  const { control, setValue } = useForm({
    mode: 'all',
  });
  const loc = useLocation();
  const [searchQuery, setSearchQuery] = useState('');

  // Filter addresses by type and productionId
  const businessAddresses = businessAddress?.data
    ?.filter(
      (item: any) =>
        (item.addressType === addressType &&
          item.productionId === getValuesFromParent('Production')?._id) ||
        item.productionId ===
          getValuesFromParent(`addMoreItems.${index}.Production`)?._id,
    )
    .sort((a, b) => {
      const nameA = (a.locationName || '').toLowerCase();
      const nameB = (b.locationName || '').toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });

  console.log(
    getValuesFromParent('Production'),
    "getValuesFromParent('Production')",
    getValuesFromParent(`addMoreItems.${index}.Production`),
    index,
    getValuesFromParent(`addMoreItems.${index}.Production`)?._id,
  );

  // Filter addresses by searchQuery (case insensitive)
  const filteredAddresses = businessAddresses?.filter((item: any) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      item?.locationName?.toLowerCase().includes(searchLower) ||
      item?.productionName?.toLowerCase().includes(searchLower) ||
      item?.setName?.toLowerCase().includes(searchLower)
    );
  });

  const fetchLocation = async () => {
    try {
      const cachedLocation = localStorage.getItem('userLocation');
      if (cachedLocation) {
        const loc = JSON.parse(cachedLocation);
        const location: any = await getAddress(loc?.latitude, loc?.longitude);

        updateCabService('pickup', {
          locationName: location?.locationName,
          coordinates: {
            type: 'Point',
            coordinates: [loc.latitude, loc.longitude],
          },
        });
        handleClose();
        return;
      }

      const { latitude, longitude }: any = await getCurrentLocation();
      const currentLocation: any = { latitude, longitude };
      localStorage.setItem('userLocation', JSON.stringify(currentLocation));
      const location: any = await getAddress(
        currentLocation?.latitude,
        currentLocation?.longitude,
      );

      updateCabService('pickup', {
        locationName: location?.locationName,
        coordinates: {
          type: 'Point',
          coordinates: [currentLocation.latitude, currentLocation.longitude],
        },
      });
      handleClose();
    } catch (err: any) {
      notify(err.message, 'error');
    }
  };

  const formatNames = (arr: string[] | any) => {
    if (!arr || arr.length === 0) return { text: '', extraCount: 0 };
    if (arr.length <= 1) return { text: arr.join(', '), extraCount: 0 };

    return { text: `${arr[0]}`, extraCount: arr.length - 1 };
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setSearchQuery('');
        handleClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="dialogWrapper warning orderAddress w__600">
        {loader ? (
          <Loading type="div" height="full" />
        ) : (
          <>
            <div className="dialogHeader flex sps_between">
              <h4 className="small">Provide Set Details</h4>
              <IconButton onClick={handleClose}>
                <img src={Images.CLOSE} alt={tC('close')} />
              </IconButton>
            </div>
            <div className="doalogBody small">
              <div className="formContainer">
                <Grid container spacing={2}>
                  <Grid item md={12} xs={12}>
                    <div className="addNewAddress pt0">
                      {type === 'cabService' ? (
                        <>
                          <AutoCompleteLocation
                            id="addressLocation"
                            labelText={tC('address')}
                            placeHolderText={tC('enter_address')}
                            name="address"
                            control={control}
                            setValue={setValue}
                            limit={100}
                            setLatLong={() => {}}
                            changeCallBack={(result: any, newV: any) => {
                              if (result) {
                                const locationData = {
                                  locationName: newV?.description,
                                  coordinates: {
                                    type: 'Point',
                                    coordinates: [
                                      result?.geometry?.location?.lat(),
                                      result?.geometry?.location?.lng(),
                                    ],
                                  },
                                };
                                updateCabService(pickupType, locationData);

                                if (result?.address_components) {
                                  handleClose();
                                }
                              }
                            }}
                            isObject={true}
                            error={false}
                            helperText=""
                          />

                          {pickupType === 'pickup' && (
                            <CustomButton
                              id=""
                              text="Current Location"
                              onClick={fetchLocation}
                              variant="text"
                              showIcon
                              iconPosition="start"
                              icon={Images.Add_Ic}
                              iconType="image"
                              width="auto"
                              size="large"
                              className="pl6"
                              isMobileTextVisible={true}
                            />
                          )}
                        </>
                      ) : (
                        <CustomButton
                          id=""
                          text="Add new address"
                          onClick={() => {
                            navigate(
                              `/location?productionId=${
                                index >= 0
                                  ? getValuesFromParent(
                                      `addMoreItems.${index}.Production`,
                                    )?._id
                                  : getValuesFromParent('Production')?._id
                              }`,
                              // {
                              //   state: {
                              //     production: {
                              //       id:
                              //         index >= 0
                              //           ? getValuesFromParent(
                              //               `addMoreItems.${index}.Production`,
                              //             )?._id
                              //           : getValuesFromParent('Production')
                              //               ?._id,
                              //       label:
                              //         index >= 0
                              //           ? getValuesFromParent(
                              //               `addMoreItems.${index}.Production`,
                              //             )?.name
                              //           : getValuesFromParent('Production')
                              //               ?.name,
                              //       type:
                              //         index >= 0
                              //           ? getValuesFromParent(
                              //               `addMoreItems.${index}.Production`,
                              //             )?.type
                              //           : getValuesFromParent('Production')
                              //               ?.type,
                              //     },
                              //     ...state,
                              //     url: loc.pathname + loc.search,
                              //   },
                              // },
                            );
                          }}
                          variant="text"
                          showIcon
                          iconPosition="start"
                          icon={Images.Add_Ic}
                          iconType="image"
                          width="auto"
                          size="large"
                          className="pl6"
                          isMobileTextVisible={true}
                        />
                      )}
                    </div>
                  </Grid>

                  {/* Search input with icon */}
                  <Grid item md={12} xs={12}>
                    <SearchInput
                      placeholder={'Search for an address...'}
                      className="sm outlined"
                      // setQuery={(value: any) => onSearch(value)}
                      setSearchKey={setSearchQuery}
                      searchkey={searchQuery}
                      handleClearSearch={() => {
                        setSearchQuery('');
                      }}
                    />
                  </Grid>

                  {/* Address list */}
                  <Grid item md={12} xs={12}>
                    {addressType === 'BUSINESS' ? (
                      <div className="savedAddress">
                        <ul>
                          {filteredAddresses?.length > 0 ? (
                            filteredAddresses.map((item: any, i: number) => (
                              <li
                                key={i}
                                onClick={() => {
                                  props.handleLocation(item);
                                  setSearchQuery('');
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                <figure>
                                  <img
                                    src={Images.PRODUCTION_ACTIVE}
                                    alt="Location"
                                  />
                                </figure>
                                <div className="text">
                                  <h4>{item?.productionName}</h4>
                                  {item?.episodeName ? (
                                    <h3>
                                      {item?.episodeNumber
                                        ? `${item?.episodeNumber} - `
                                        : ''}{' '}
                                      {item?.episodeName}
                                    </h3>
                                  ) : null}
                                  <h3>{item?.setName?.toUpperCase()}</h3>
                                  {item?.locationPurpose?.length
                                    ? (() => {
                                        const { text, extraCount } =
                                          formatNames(item?.locationPurpose);
                                        return (
                                          <>
                                            <div className="d-flex align-center mb-4">
                                              <p className="text-text MuiTypography-subtitle1 fw600 text-black100">
                                                {text}
                                                {extraCount > 0 ? (
                                                  <ToolTipComponent
                                                    theme="light"
                                                    title={Object.entries(
                                                      item?.locationPurpose,
                                                    )
                                                      .slice(1) // Get all remaining key-value pairs
                                                      .map(
                                                        ([_, value]) =>
                                                          `${value}`,
                                                      )
                                                      .join(', ')}
                                                  >
                                                    <span className="tooltip-label ml-10">
                                                      +{extraCount}
                                                    </span>
                                                  </ToolTipComponent>
                                                ) : null}
                                              </p>
                                            </div>
                                          </>
                                        );
                                      })()
                                    : null}
                                  <p>{item?.locationName}</p>
                                </div>
                              </li>
                            ))
                          ) : (
                            <NoData heading="No Address found." />
                          )}
                        </ul>
                      </div>
                    ) : (
                      <div className="savedAddress">
                        <ul>
                          {businessAddresses?.map((item: any, i: number) => (
                            <li key={i}>
                              <figure>
                                <img src={Images.Drop_Map_Ic} alt="Location" />
                              </figure>
                              <div className="text">
                                <h4>{item?.buildingName}</h4>
                                <h3>{item?.apartment}</h3>
                                {item?.locationPurpose?.length
                                  ? (() => {
                                      const { text, extraCount } = formatNames(
                                        item?.locationPurpose,
                                      );
                                      return (
                                        <>
                                          <div className="d-flex align-center mb-4">
                                            <p className="text-text MuiTypography-subtitle1 fw600 text-black100">
                                              {text}
                                              {extraCount > 0 ? (
                                                <ToolTipComponent
                                                  theme="light"
                                                  title={Object.entries(
                                                    item?.locationPurpose,
                                                  )
                                                    .slice(1) // Get all remaining key-value pairs
                                                    .map(
                                                      ([_, value]) =>
                                                        `${value}`,
                                                    )
                                                    .join(', ')}
                                                >
                                                  <span className="tooltip-label ml-10">
                                                    +{extraCount}
                                                  </span>
                                                </ToolTipComponent>
                                              ) : null}
                                            </p>
                                          </div>
                                        </>
                                      );
                                    })()
                                  : null}
                                <p>{item?.addressLabel}</p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Grid>
                </Grid>
              </div>
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
}
